import React, { useState, useEffect } from 'react';
import { FiFolder } from 'react-icons/fi';
import styles from './CategorySelect.module.css';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import CategoryEdtSelectModal from '../CategoryEdtSelectModal/CategoryEdtSelectModal';
import CategoryCreateSelectModal from '../CategoryCreateSelectModal/CategoryCreateSelectModal';

import AxiosUrl from '../AxiosUrl';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function CategorySelect() {
    const uid = localStorage.getItem('id');
    const [category, setCategory] = useState([]);
    const [open, setOpenModal] = useState(false);
    const [openCategory, setOpenCategoryModal] = useState(false);

    const [data, setData] = useState('');
    const [refresh, setRefresh] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getCategory();
    }, [open, refresh, openCategory]);

    const getCategory = () => {
        setLoading(true);
        AxiosUrl.get(`/home-category/${uid}`)
            .then((res) => {
                setCategory(res.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    const deleteCategory = (cid) => {
        const confirmDelete = window.confirm(
            'Are you sure you want to delete this category?'
        );
        if (confirmDelete) {
            setRefresh(false);
            AxiosUrl.post(`/home-delete-category/${uid}`, { cid })
                .then((res) => {
                    toast.success('Deleted successfully.');
                    setRefresh(true);
                })
                .catch(() => {
                    toast.error('Failed to delete.');
                });
        }
    };

    return (
        <>
            <ToastContainer />
            {open && (
                <CategoryEdtSelectModal
                    setOpenModal={setOpenModal}
                    data={data}
                />
            )}
            {openCategory && (
                <CategoryCreateSelectModal
                    setOpenCategoryModal={setOpenCategoryModal}
                />
            )}
            <div style={{ minHeight: '90vh', padding: '0' }}>
                <div
                    style={{
                        background: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    {/* Header */}
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '24px',
                        }}
                    >
                        <h1
                            style={{
                                fontSize: '24px',
                                fontWeight: '600',
                                color: '#202223',
                                margin: 0,
                            }}
                        >
                            Home Categories
                        </h1>
                        <Button
                            variant="contained"
                            onClick={() => setOpenCategoryModal(true)}
                            style={{
                                backgroundColor: '#008060',
                                color: 'white',
                                textTransform: 'none',
                                padding: '10px 20px',
                                fontSize: '14px',
                                fontWeight: '500',
                                borderRadius: '8px',
                                boxShadow: 'none',
                            }}
                        >
                            Add Home Category
                        </Button>
                    </div>

                <TableContainer
                    component={Paper}
                    style={{
                        borderRadius: '12px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
                        border: '1px solid #e1e3e5',
                    }}
                >
                    <Table>
                        <TableHead style={{ background: '#f8fafc' }}>
                            <TableRow>
                                <TableCell style={{ fontWeight: '600', color: '#202223' }}>
                                    #
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: '600', color: '#202223' }}>
                                    Status
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: '600', color: '#202223' }}>
                                    Set Category
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: '600', color: '#202223' }}>
                                    Selected Category
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: '600', color: '#202223' }}>
                                    Actions
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loading ? (
                                <>
                                    {[...Array(8)].map((_, i) => (
                                        <TableRow key={i}>
                                            <TableCell>
                                                <div className={styles.skeleton} style={{ width: '20px', height: '16px' }}></div>
                                            </TableCell>
                                            <TableCell align="center">
                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <div className={styles.skeleton} style={{ width: '60px', height: '24px', borderRadius: '12px' }}></div>
                                                </div>
                                            </TableCell>
                                            <TableCell align="center">
                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <div className={styles.skeleton} style={{ width: '120px', height: '32px', borderRadius: '8px' }}></div>
                                                </div>
                                            </TableCell>
                                            <TableCell align="center">
                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <div className={styles.skeleton} style={{ width: `${80 + (i % 3) * 20}px`, height: '28px', borderRadius: '8px' }}></div>
                                                </div>
                                            </TableCell>
                                            <TableCell align="center">
                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <div className={styles.skeleton} style={{ width: '65px', height: '32px', borderRadius: '8px' }}></div>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </>
                            ) : null}
                            {!loading && category.length <= 0 ? (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        <div style={{ padding: '60px 20px' }}>
                                            <div style={{ fontSize: '48px' }}><FiFolder /></div>
                                            <h3
                                                style={{
                                                    fontSize: '18px',
                                                    fontWeight: '600',
                                                    color: '#202223',
                                                    margin: '16px 0 8px 0',
                                                }}
                                            >
                                                No home categories found
                                            </h3>
                                            <p
                                                style={{
                                                    fontSize: '14px',
                                                    color: '#6d7175',
                                                    margin: 0,
                                                }}
                                            >
                                                Get started by adding your first home category
                                            </p>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                category.map((data, index) => {
                                    return (
                                        <TableRow
                                            key={data._id}
                                            sx={{
                                                '&:hover': {
                                                    backgroundColor: '#f9fafb',
                                                },
                                                transition: 'background-color 0.15s ease',
                                            }}
                                        >
                                            <TableCell style={{ fontSize: '14px', fontWeight: '500' }}>
                                                {index + 1}
                                            </TableCell>

                                            <TableCell align="center">
                                                <span
                                                    style={{
                                                        backgroundColor:
                                                            data.status === '0'
                                                                ? '#fef2f2'
                                                                : '#f0fdf4',
                                                        color:
                                                            data.status === '0'
                                                                ? '#991b1b'
                                                                : '#166534',
                                                        padding: '4px 12px',
                                                        fontSize: '12px',
                                                        fontWeight: '500',
                                                        borderRadius: '12px',
                                                        display: 'inline-block',
                                                        border:
                                                            data.status === '0'
                                                                ? '1px solid #fecaca'
                                                                : '1px solid #bbf7d0',
                                                    }}
                                                >
                                                    {data.status === '0' ? 'Inactive' : 'Active'}
                                                </span>
                                            </TableCell>

                                            <TableCell align="center">
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    style={{
                                                        backgroundColor: '#f0f9ff',
                                                        color: '#0369a1',
                                                        border: '1px solid #bae6fd',
                                                        padding: '6px 16px',
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                        borderRadius: '8px',
                                                        textTransform: 'none',
                                                        boxShadow: 'none',
                                                    }}
                                                    onClick={() => {
                                                        setData(data);
                                                        setOpenModal(true);
                                                    }}
                                                >
                                                    Select Category
                                                </Button>
                                            </TableCell>
                                            <TableCell align="center">
                                                <span
                                                    style={{
                                                        backgroundColor: data.cName ? '#f0f9ff' : '#fef2f2',
                                                        color: data.cName ? '#0369a1' : '#991b1b',
                                                        padding: '6px 12px',
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                        borderRadius: '8px',
                                                        display: 'inline-block',
                                                        border: data.cName ? '1px solid #bae6fd' : '1px solid #fecaca',
                                                    }}
                                                >
                                                    {data.cName ? data.cName : 'NOT SET'}
                                                </span>
                                            </TableCell>

                                            <TableCell align="center">
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    style={{
                                                        backgroundColor: '#fef2f2',
                                                        color: '#991b1b',
                                                        border: '1px solid #fecaca',
                                                        padding: '6px 16px',
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                        borderRadius: '8px',
                                                        textTransform: 'none',
                                                        boxShadow: 'none',
                                                    }}
                                                    onClick={() =>
                                                        deleteCategory(data._id)
                                                    }
                                                >
                                                    Delete
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                </div>
            </div>
        </>
    );
}

export default CategorySelect;